import React from "react";
import Hero from "../Components/Home/Hero";
import Overview from "../Components/Home/Overview";
import Journey from "../Components/Home/Journey";
import Skills from "../Components/Home/Skills";
function Home() {
  return (
    <>
      <main>
        <article id="fullpage">
          <Hero />
          <Overview />
          <Journey />
          <Skills />
          <div className=""></div>
        </article>
      </main>
    </>
  );
}

export default Home;
